<template>
<div>
    <div class="demo-upload-list" v-for="item in uploadList" :key="item.key">
        <template v-if="item.status === 'finished'">
            <img :src="webUrl+'?fid='+item.response.data">
            <div class="demo-upload-list-cover">
                <Icon type="ios-trash-outline" @click.native="handleRemove(item)"></Icon>
            </div>
        </template>
        <template v-else>
            <Progress v-if="item.showProgress" :percent="item.percentage" hide-info></Progress>
        </template>
    </div>
    <Upload
        ref="upload"
        :show-upload-list="false"
        :default-file-list="defaultList"
        :on-success="handleSuccess"
        :format="types"
        :max-size="maxSize"
        :on-format-error="handleFormatError"
        :on-exceeded-size="handleMaxSize"
        :before-upload="handleBeforeUpload"
        :data="token"
        multiple
        type="drag"
        :action="action"
        style="display: inline-block;width:58px;">
        <div style="width: 58px;height:58px;line-height: 58px;">
            <Icon type="ios-camera" size="20"></Icon>
        </div>
    </Upload>
    
</div>
</template>
<script>
/**
 * 图片上传组件
 * @param num Number 允许上传的数量
 * @param action String 上传接口
 * @param hasUpload Array 已上传的图片
 * @param removeArray Array 已上传的图片
 * hasUpload格式
 * {
 * status:'finished',
      name: 'a42bdcc1178e62b4694c830f028db5c0',
      response:{data:'http://www.blshop.com/upload/common/20180810/fcb98054a116becbf41d941d1fc64dcb.png'}
    }
    setThumbUrl 为上传成功后回调的父组件的方法，在父组件中添加此方法
 */
import { mapState } from 'vuex'
import common from "@/common/common.js"
import * as imageConversion from 'image-conversion'
    export default {
        name:"imgUpload",
        props:{
            num:Number,//允许上传个数
            action:String,//传入上传接口
            types:{
                type:Array,
                default:()=>{
                    return ['jpg','jpeg','png', 'gif']
                }
            },
            nameReg:{
                type:RegExp,
                default:null
            },
            compressImageSize:{//,隔开，大于1，是缩小到的kb值，小于1是缩小的倍数
                type:String,
                default:''
            },
            maxSize:{
                type:Number,
                default:500
            }
        },
        data () {
            return {
                token:{},
                webUrl:this.config.sourceUrl,
                defaultList: [],//默认图片
                imgName: '',
                uploadList: [],//已上传的图片列表
            }
        },
        computed:{
            ...mapState(['local']),
        },
        methods: {
            handleRemove (file) {//删除图片
                const fileList = this.$refs.upload.fileList;
                let index = fileList.indexOf(file)
                this.$refs.upload.fileList.splice(fileList.indexOf(file), 1);
                this.$emit('removeThumbUrl', index);
            },
            clearImg () {//清除所有文件
                this.$refs.upload.clearFiles()
                this.uploadList = this.$refs.upload.fileList;
            },
            handleSuccess (res, file) {//上传成功后的处理方法

                console.log(9999999)
                if(this.compressImageSize) return  //如果需要上传原文件及压缩文件，不走下面的方法
                if(res.code == 1) {
                    common.msg('success',this.$t('img.success'))
                
                    this.$emit('setThumbUrl', {data:res.data,file:file});
                    
                }else{
                     common.msg('error',this.$t('img.failed'))
                }
            },
            handleFormatError (file) {//上传错误提示
                let typesTxt = this.types.join('、')
                this.$Notice.warning({
                    title: this.$t('upError.formatError'),
                    desc: '" '+ file.name +' " '+ this.$t('upError.formatError')+' . '+ this.$t('upError.pleaseSele')+'  '+typesTxt+'  '+this.$t('upError.type')
                    // desc: '图片' + file.name + '格式错误, 请选择 jpg 或 png图片'
                });
            },
            handleMaxSize (file) {//大小提示
                const sizeUnit  = this.maxSize >= 1024 && this.maxSize % 1024 === 0 ? 'M' : 'KB';
                const maxSize = this.maxSize >= 1024 && this.maxSize % 1024 === 0 ? this.maxSize/1024 : this.maxSize;
                let tip_zh = `文件 ${file.name} 太大，不能超过 ${maxSize}${sizeUnit}`
                let tip_en = `File ${file.name} is too large (max ${maxSize}${sizeUnit} allowed)`
                
                this.$Notice.warning({
                    title: 'Exceeding file size limit',
                    desc: this.local=='zh-CN'?tip_zh:tip_en
                });

                console.log('大小提示')
            },
            async handleBeforeUpload (file) {//上传数量限制/名称限制
               
                return new Promise(async (resolve, reject) => {
                    const check = this.uploadList.length < this.num;
                    let tip_zh = `最多只能上传 ${this.num} 张图片`
                    let tip_en = `You can upload up to ${this.num} images maximum`
                    if (!check) {
                        this.$Notice.warning({
                            title:'Exceeding file number limit',
                            desc: this.local=='zh-CN'?tip_zh:tip_en
                        });
                    }
    
                    let checkName = true

                    // console.log('this.nameReg.test(file.name)',this.nameReg.test(file.name))
                    
                    if(this.nameReg && !this.nameReg.test(file.name)){
                        this.$Notice.warning({
                            title:this.$t('upError.name'),
                        });
                        checkName = false
                    } 
    
                    
                    // 保存文件到总展示文件数据里
                    if(check && checkName && this.compressImageSize){
                      await  this.handleCompressImage(file)
                    }

                    if(check && checkName){
                        return resolve(true)
                    }else{
                        return reject(false);
                    }

                  });
            },
            async handleBeforeUpload1 (file) {//上传数量限制/名称限制
                const check = this.uploadList.length < this.num;
                let tip_zh = `最多只能上传 ${this.num} 张图片`
                let tip_en = `You can upload up to ${this.num} images maximum`
                if (!check) {
                    this.$Notice.warning({
                        title:'Exceeding file number limit',
                        desc: this.local=='zh-CN'?tip_zh:tip_en
                    });
                }
    

                let checkName = true

                
                
                if(this.nameReg && !this.nameReg.test(file.name)){
                    this.$Notice.warning({
                        title:this.$t('upError.name'),
                        // desc: '最多只能上传'+this.num+'张图片'
                    });
                    checkName = false
                } 

                
                // 保存文件到总展示文件数据里
                if(check && checkName && this.compressImageSize){
                  await  this.handleCompressImage(file)
                }


                console.log('check && checkName',check && checkName)

                return check && checkName;
            },
            setHasUpload (hasUpload) {//编辑时赋值
                // console.log('hasUpload',hasUpload)
                this.$refs.upload.fileList = hasUpload
                this.uploadList = this.$refs.upload.fileList;
            },
            async handleCompressImage(file){
                // 上传之前校验
                  console.log('压缩前', file) // 压缩到400KB,大于400KB的图片都会进行压缩，小于则不会

                
                  let resUrl = []
                  let formdata = new FormData()
                  formdata.append('file',file)

                    let res = await  this.axios.post(this.action, formdata,{
                         headers:{
                            'Content-Type':'multipart/form-data'   //hearder 很重要，Content-Type 要写对
                         }
                       })
                    if(res && res.data.code==1) {
                        resUrl.push(res.data.data) 
                    }else{
                        return
                    }

                   

                  let resUrlOne = await this.handleCompressImageItem(file)
            
                    this.$emit('setThumbUrl', {data:[...resUrl,...resUrlOne]});
                 
            },
            async handleCompressImageItem(file){

                let compressImageSizeArr = this.compressImageSize.split(',')
                let sizeArray = []
                let resUrl = []

                // console.log('compressImageSizeArr',compressImageSizeArr)

                for(let i=0;i<compressImageSizeArr.length;i++){
                    let size = file.size/1024>compressImageSizeArr[i]?compressImageSizeArr[i]:file.size/1024
                    sizeArray.push(size)
                }

                for(let i=0;i<sizeArray.length;i++){
                    let CompressImageOne = await imageConversion.compressAccurately(file,sizeArray[i])
                    let fileOne = null
                    if(CompressImageOne) fileOne = new File([CompressImageOne], file.name, { type: CompressImageOne.type, lastModified: Date.now() })

                    let formdataOne = new FormData()
                    formdataOne.append('file',fileOne)
                    let resOne = await this.axios.post(this.action, formdataOne,{
                         headers:{
                            'Content-Type':'multipart/form-data'   //hearder 很重要，Content-Type 要写对
                         }
                       })
                    if(resOne && resOne.data.code==1) resUrl.push(resOne.data.data) 
                }
                return resUrl
            },

        },
        mounted () {
            // this.token.token = common.getToken()
            this.uploadList = this.$refs.upload.fileList;
        }
    }
</script>
<style>
    .demo-upload-list{
        display: inline-block;
        width: 60px;
        height: 60px;
        text-align: center;
        line-height: 60px;
        border: 1px solid transparent;
        border-radius: 4px;
        overflow: hidden;
        background: #fff;
        position: relative;
        box-shadow: 0 1px 1px rgba(0,0,0,.2);
        margin-right: 4px;
    }
    .demo-upload-list img{
        width: 100%;
        height: 100%;
        object-fit: contain;
    }
    .demo-upload-list-cover{
        display: none;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        background: rgba(0,0,0,.6);
    }
    .demo-upload-list:hover .demo-upload-list-cover{
        display: block;
    }
    .demo-upload-list-cover i{
        color: #fff;
        font-size: 20px;
        cursor: pointer;
        margin: 0 2px;
    }
</style>
